import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../../../common/html/element'
import { Icon } from '../../../../../../../../../common/html/icon'
import { Tooltip } from '../../../../../../../../../common/tooltip'
import {
  FORMAT,
  formatDateTime,
} from '../../../../../../../../../helpers/datetime'
import { formatText } from '../../../../../../../../../helpers/value'
import { SCORE_PERFORMANCE_COLORS_ID } from '../../../../../../constant'
import { getIdRangesPerformanceByScore } from '../../performanceScore/helper'
import { rangesPerformanceRaw } from '../../performanceScore/store/slice'

export const CustomTdPerformanceScore = ({ val, locale, isDynamicReport }) => {
  const { performanceScore, publicDate, isLastQuarter } = val
  const data = useSelector(rangesPerformanceRaw)
  const idRange = getIdRangesPerformanceByScore(data, performanceScore)

  return (
    <div className="dFlex justifyContentCenter">
      <Element
        className="dFlex justifyContentCenter alignItemsCenter"
        style={{
          backgroundColor: SCORE_PERFORMANCE_COLORS_ID[idRange],
          lineHeight: '16px',
          fontWeight: 600,
          width: 60,
          color: '#3A414B',
        }}
      >
        <Element>{formatText(performanceScore)}</Element>
        {!isLastQuarter && !!performanceScore && !isDynamicReport && (
          <Tooltip
            tooltipContent={
              <div className="dFlex gap1">
                <Translate value="score.main.LAST_UPDATE_DATE" />
                {formatDateTime(publicDate, FORMAT.DATE, locale)}
              </div>
            }
          >
            <Icon
              className="icon-info-circle"
              style={{
                fontSize: 10,
                paddingLeft: 5,
              }}
            />
          </Tooltip>
        )}
      </Element>
    </div>
  )
}
